import { EnergyType } from '../EnergyFlow'
import { LocalGridProvider } from './common/LocalGridProvider'

/**
 * Fully provides for the electricity demand and requests the same amount of
 * energy from the local electricity grid.
 */
export class LocalElectricalGridProvider extends LocalGridProvider {
  public readonly providedEnergyTypes = [EnergyType.Electricity]
}
